<template>

    <v-container class="fill-height" style="display: block;" fluid :class="{'widget-mode': $props.widgetMode}">

    <template v-if="$store.state.batchConfig.webapp_issues">

        <div v-if="showGrid && !$props.widgetMode">
            <h3 style="display: inline-block" v-text="(issuesMode == 'current' ? 'Current Issues' : 'Historical Issues')"></h3>
            <v-menu>
                <template #activator="{ on: onMenu }">

                    <span v-on="onMenu" style="margin-left: -35px; position: absolute;" />
                    <v-tooltip bottom v-on="onMenu" color="rgba(97, 97, 97, 1.0)">
                        <template #activator="{ on: onTooltip }">
                            <v-btn class="ml-3 mb-2 grid-button" title="Issues Menu" fab dark x-small color="#c42111" v-on="{ ...onMenu, ...onTooltip }">
                                <v-icon dark>mdi-menu</v-icon>
                            </v-btn>
                        </template>
                        <span>Issues Menu</span>
                    </v-tooltip>

                </template>
                <v-list>
                    <v-list-item @click="issuesDrawerToggle">
                        <v-list-item-title><v-icon :size="'16'">mdi-view-column</v-icon> Action Drawer</v-list-item-title>
                    </v-list-item>

                    <v-list-group :value="false" no-action color="#ffffff" @click.stop="">
                        <template v-slot:activator>
                            <v-list-item-title><v-icon :size="'16'">mdi-format-letter-case</v-icon> Density</v-list-item-title>
                        </template>

                        <v-list-item @click="toggleGridSmallMode">
                            <v-icon class="density-check" :size="'16'" v-if="!gridSmallMode">mdi-check-bold</v-icon>
                            <v-list-item-title>Comfortable</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="toggleGridSmallMode">
                            <v-icon class="density-check" :size="'16'" v-if="gridSmallMode">mdi-check-bold</v-icon>
                            <v-list-item-title>Compact</v-list-item-title>
                        </v-list-item>
                    </v-list-group>

                    <v-list-item @click="refreshIssuesList('user request')" v-if="current">
                        <v-list-item-title><v-icon :size="'16'">mdi-refresh</v-icon> Refresh List</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="showViewsFavsDetails = true">
                        <v-list-item-title><v-icon :size="'16'">mdi-content-save</v-icon>{{` Save Issues View${$store.state.user.device_type ? ` (${$store.state.user.device_type})` : ''}`}}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showViewManagementClick" v-if="current">
                        <v-list-item-title><v-icon :size="'16'">mdi-monitor-multiple</v-icon> Issues View Management</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="clearView">
                        <v-list-item-title><v-icon :size="'16'">mdi-layers-remove</v-icon> Clear View</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="showIssueTemplates = true" v-if="current">
                        <v-list-item-title><v-icon :size="'16'">mdi-note-multiple</v-icon> Issue Templates</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showRecurringIssues = true" v-if="current">
                        <v-list-item-title><v-icon :size="'16'">mdi-calendar-edit</v-icon> Schedule Issues</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showHistoricalParams = true">
                        <v-list-item-title><v-icon :size="'16'">mdi-history</v-icon> Historical Issues</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="currentIssuesClick" v-if="!current">
                        <v-list-item-title><v-icon :size="'16'">mdi-sticker-alert</v-icon> Current Issues</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showResources = true" v-if="current">
                        <v-list-item-title><v-icon :size="'16'">mdi-playlist-edit</v-icon> Resources</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showIssueTags = true" v-if="current">
                        <v-list-item-title><v-icon :size="'16'">mdi-tag-multiple</v-icon> Issue Tags</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportToExcelFile">
                        <v-list-item-title><v-icon :size="'16'">mdi-file-excel</v-icon> Excel Data File</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="exportToCsvFile">
                        <v-list-item-title><v-icon :size="'16'">mdi-file</v-icon> CSV File</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>

            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn class="ml-3 mb-2 grid-button" title="Create New Issue" fab dark x-small color="#c42111" @click="createNewIssue(null)" v-on="on"><v-icon dark>mdi-plus</v-icon></v-btn>
                </template>
                <span>Create New Issue</span>
            </v-tooltip>

            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn class="ml-3 mb-2 grid-button" title="Create Issue Templates" fab dark x-small color="#c42111" @click="showIssueTemplates = true" v-on="on"><v-icon dark>mdi-note-plus</v-icon></v-btn>
                </template>
                <span>Create Issue Templates</span>
            </v-tooltip>

            <div class="days-closed-container" v-if="current">
                <span>Days Closed</span>
                <input type="number" min="0" step="1" v-model="daysClosed" @input="debounceDaysClosed" />
            </div>

            <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                <template v-slot:activator="{ on }">
                    <v-btn class="ml-3 mb-2 grid-button" title="Fullscreen" fab dark x-small color="#c42111" @click="toggleFullscreen" v-on="on"><v-icon dark>mdi-fullscreen</v-icon></v-btn>
                </template>
                <span>Fullscreen</span>
            </v-tooltip>

            <div class="view-select-container">
                <v-select class="view-select" outlined label="Issue View" color="#c42111" :items="issueViewsFavs" v-model="selectedIssueView" return-object item-text="view_name" @change="applyGridConfig">
                    <template v-slot:item="{item}">
                        <span v-text="item.view_name" />
                        <span class="view-select-default-text" v-text="'DEFAULT'" v-if="item.default" />
                    </template>
                </v-select>

                <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-btn class="ml-3 view-button" fab dark x-small color="#c42111" @click="showViewsFavsDetails = true" title="Save Issue View" v-on="on">
                            <v-icon>mdi-content-save</v-icon>
                        </v-btn>
                    </template>
                    <span>Save Issue View</span>
                </v-tooltip>

                <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-btn class="ml-2 view-button" fab dark x-small color="#c42111" @click="showViewManagementClick" title="Issue View Management" v-on="on">
                            <v-icon>mdi-monitor-multiple</v-icon>
                        </v-btn>
                    </template>
                    <span>Issue View Management</span>
                </v-tooltip>

                <v-tooltip bottom color="rgba(97, 97, 97, 1.0)">
                    <template v-slot:activator="{ on }">
                        <v-btn class="ml-2 view-button" fab dark x-small color="#c42111" @click="clearView" title="Clear View" v-on="on">
                            <v-icon>mdi-layers-remove</v-icon>
                        </v-btn>
                    </template>
                    <span>Clear View</span>
                </v-tooltip>
            </div>
        </div>

        <div id="ag-grid-issues-container-fullscreen" :class="{'widget-mode': $props.widgetMode}">
            <v-overlay id="ag-grid-alarms-container-fullscreen-overlay" v-if="($store.getters.fullscreenIsActive && ($store.getters.dialogIsActive || showIssueDetails || showAddRemark || showIssueTemplates || showRecurringIssues || showResources || showIssueTags))" />
            <div id="ag-grid-issues-container" :class="{drawer: issuesDrawer}">
                <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                    :gridOptions="gridOptions"
                    :groupHeaders="true"
                    :rowSelection="'multiple'"
                    :rowDeselection="true"
                    @selection-changed="onRowSelectionChanged"
                    @row-double-clicked="issueDetails"
                    :getRowHeight="getRowHeight"
                    :suppressDragLeaveHidesColumns="true"
                    :suppressMakeColumnVisibleAfterUnGroup="true"
                    :rowGroupPanelShow="'always'"
                    :groupSelectsChildren="true"
                    :groupSelectsFiltered="true"
                    :sendToClipboard="sendToClipboard">
                </ag-grid-vue>
            </div>

            <div id="issues-drawer" :class="{active: issuesDrawer && showGrid}">
                <action-drawer :selectedRows="selectedRows" :show="issuesDrawer && showGrid" :current="current"
                    @details="issueDetails"
                    @close="closeIssuesClick"
                    @remark="addRemarkClick"
                    @schedule="createRecurringIssue"
                >
                </action-drawer>
            </div>
        </div>

        <span class="refresh-text" v-text="current ? issuesRefreshText : `Historical Issues: ${issuesList.length} results`" />
        <span class="row-count-text" v-if="showGrid && gridApi">
            <span> {{ `${gridApi.getDisplayedRowCount()} rows, ` }}</span>
            <span>{{ `${selectedRows.length} selected`}}</span>
        </span>

        <v-dialog v-model="showIssueDetails" max-width="80%" width="1600px" persistent :attach="$store.state.fullscreenElement">
            <issue-details v-if="showIssueDetails" @close="closeIssueDetails" :issue="selectedIssue" :type="selectedIssueType" :resources="resources" :templateName="createNewIssueFromTemplateName"></issue-details>
        </v-dialog>

        <v-dialog v-model="showAddRemark" max-width="80%" width="500px" persistent :attach="$store.state.fullscreenElement" @keydown="(k) => {k.key == 'Escape' ? showAddRemark = false : null}">
            <add-remark v-if="showAddRemark" @cancel="showAddRemark = false; addRemarkId = null;" @ok="addRemark"></add-remark>
        </v-dialog>

        <v-dialog v-model="showIssueTemplates" max-width="80%" width="1500px" persistent :attach="$store.state.fullscreenElement">
            <issue-templates v-if="showIssueTemplates" @close="showIssueTemplates = false;" :resources="resources" @createIssue="createNewIssueFromTemplate"></issue-templates>
        </v-dialog>

        <v-dialog v-model="showRecurringIssues" max-width="80%" width="1500px" persistent :attach="$store.state.fullscreenElement">
            <schedule-issues v-if="showRecurringIssues" @close="showRecurringIssues = false; recurringIssueIssue = null;" :resources="resources" :recurringIssueIssue="recurringIssueIssue"></schedule-issues>
        </v-dialog>

        <v-dialog v-model="showResources" max-width="80%" width="1000px" persistent :attach="$store.state.fullscreenElement">
            <issues-resources v-if="showResources" @close="showResources = false; $store.dispatch('handleRemoveLocks');" @ok="issueResourcesModified"></issues-resources>
        </v-dialog>

        <v-dialog v-model="showIssueTags" max-width="80%" width="1400px" persistent :attach="$store.state.fullscreenElement">
            <issue-tags v-if="showIssueTags" @reload="getResources(); refreshIssuesList('parameter changed');" @close="showIssueTags = false; $store.dispatch('handleRemoveLocks');"></issue-tags>
        </v-dialog>
        
        <v-dialog v-model="showHistoricalParams" max-width="80%" width="1000px" persistent @keydown="(k) => {k.key == 'Escape' ? showHistoricalParams = false : null}">
            <historical-params v-if="showHistoricalParams" :historicalIssuesParams="historicalIssuesParams" @cancel="showHistoricalParams = false" @run="runHistoricalIssues"></historical-params>
        </v-dialog>

        <v-dialog v-model="showViewManagement" max-width="80%" width="1400px" persistent v-if="showViewManagement" @keydown="(k) => {k.key == 'Escape' ? showViewManagement = false : null}">
            <view-management :viewType="'issue'" :views="issueViews" :currentViewGridConfig="currentViewGridConfig" @close="showViewManagement = false" @open="(view) => {this.selectedIssueView = view; applyGridConfig();}" @delete="handleViewDelete"></view-management>
        </v-dialog>

        <v-dialog v-model="showViewsFavsDetails" max-width="80%" width="550px" persistent v-if="showViewsFavsDetails" @keydown="(k) => {k.key == 'Escape' ? showViewsFavsDetails = false : null}">
            <views-favs-details :viewType="'issue'" :selectedView="selectedIssueView" :views="issueViews" @cancel="showViewsFavsDetails = false" @new="saveNewView" @overwrite="overwriteView"></views-favs-details>
        </v-dialog>

    </template>



    <template v-if="!$store.state.batchConfig.webapp_issues">
        <div class="no-license-text">
            <p>
                You do not have a license for Telsasoft Issues. <br>
                Please visit <a style="color:#c42111;" href="https://telsasoft.com/" target="_blank">here</a> for more information.
            </p>
        </div>
    </template>

    </v-container>
</template>

<script>
import _ from 'lodash';
import { AgGridVue } from "ag-grid-vue";
import "../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import { CustomAggFuncs, rowColorFuncs } from "@/components/Alarms/AlarmFuncs";
import ActionDrawer from "@/components/Issues/ActionDrawer";
import IssueDetails from "@/components/Issues/IssueDetails";
import AddRemark from "@/components/Issues/AddRemark";
import IssueTemplates from "@/components/Issues/IssueTemplates";
import ScheduleIssues from "@/components/Issues/ScheduleIssues";
import IssuesResources from "@/components/Issues/IssuesResources";
import IssueTags from "@/components/Issues/IssueTags";
import HistoricalParams from "@/components/Issues/HistoricalParams";
import ViewManagement from "@/components/ViewManagement";
import ViewsFavsDetails from "@/components/ViewsFavsDetails";

import { issueDateFilterParams } from "@/components/Issues/IssueFuncs";

export default {
    name: 'Issues',
    props: ['widgetMode', 'widgetCommand'],
    components: {
        'ag-grid-vue': AgGridVue,
        ActionDrawer,
        IssueDetails,
        AddRemark,
        IssueTemplates,
        ScheduleIssues,
        IssuesResources,
        IssueTags,
        HistoricalParams,
        ViewManagement,
        ViewsFavsDetails
    },
    data: () => ({
        issuesDrawer: false,
        daysClosed: 0,
        issuesList: [],
        resources: {
            sites: [],
            categories: [],
            services: [],
            causes: []
        },
        showGrid: false,
        gridOptions: {},
        gridApi: null,
        gridSmallMode: false,
        selectedRows: [],
        selectedIssue: null,
        selectedIssueType: null,
        issuesMode: 'current', // 'current' or 'historical'
        issuesRefreshTime: null,
        issuesRefreshText: '',
        showIssueDetails: false,
        showAddRemark: false,
        addRemarkId: null,
        pollCheck: null,
        showIssueTemplates: false,
        showRecurringIssues: false,
        recurringIssueIssue: null,
        showResources: false,
        showIssueTags: false,
        showHistoricalParams: false,
        historicalIssuesParams: null,

        statusList: ['Open', 'In Progress', 'Monitoring', 'Need Update', 'Delinquent', 'Completed', 'Closed', 'Duplicate'],
        affectedList: ['DS0s', 'DS1s', 'DS3s', 'Users'],
        priorityList: ['Highest', 'High', 'Normal', 'Low'],
        severityList: ['CRITICAL', 'MAJOR', 'MINOR', 'OBSERVATIONAL'],
        technicianOptions: [],
        localeOptions: [],
        issueTagOptions: [],

        issueViews: [],
        selectedIssueView: null,
        showViewsFavsDetails: false,
        showViewManagement: false,
        currentViewGridConfig: null,
        defaultColumnState: null,

        issueSubscriptionUnsubscribeFunc: null,
        createNewIssueFromTemplateName: null
    }),

    computed: {
        current: function() {
            return (this.issuesMode == 'current');
        },

        issueTrayFilter: function() {
            return this.$store.state.issueTrayFilter;
        },

        gridRowPadding: function() {
            return (this.gridSmallMode ? '0px' : '8px');
        },

        issueViewsFavs: function() {
            return this.issueViews.length ? this.issueViews.filter(v => {return v.fav}) : [];
        }
    },

    methods: {
        debounceDaysClosed: _.debounce(function() {
            this.daysClosed = Math.floor(this.daysClosed);
            this.refreshIssuesList('parameter changed');
        }, 500),

        getResources: function() {
            let route = (TELSA.apiHost + "issues/resources");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.resources.categories = result.categories;
                this.resources.causes = result.causes;
                this.resources.services = result.services;
                this.resources.issue_tags = result.issue_tags;
                this.issueTagOptions = result.issue_tags.map(t => t.issue_tag_name);
            });
        },

        issueResourcesModified: function() {
            this.showResources = false; 
            this.$store.dispatch('handleRemoveLocks'); 
            this.refreshIssuesList('user request');
        },

        getSetFilterResources: function() {
            let route = `${TELSA.apiHost}alarms/historicalresources`;
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.technicianOptions = result.technician_list;
                this.localeOptions = result.locale_list;
            });
        },

        getIssueViews: function() {
            let route = `${TELSA.apiHost}views/list/issue`;
            return this.$http.get(route).then(response => {
                let results = response.body;
                console.log('ISSUE VIEWS: ', results);
                this.issueViews = results;
                this.selectedIssueView = this.selectedIssueView || this.issueViewsFavs.find(v => {return v.default}) || (this.issueViewsFavs.length ? this.issueViewsFavs[0] : null);
            });
        },
        overwriteView: function() {
            TELSA.loading(true);
            this.showViewsFavsDetails = false;
            this.selectedIssueView.view_grid_config = {
                gridData: this.gridOptions.columnApi.getColumnState(),
                filterData: this.gridOptions.api.getFilterModel(),
                sortData: this.gridOptions.api.getSortModel(),
                issuesDrawer: this.issuesDrawer,
                issueDrawerWidthPct: (parseFloat((document.getElementById('issues-drawer').offsetWidth / document.getElementById('telsasoft-application').offsetWidth).toFixed(2))),
                gridSmallMode: this.gridSmallMode
            };
            let route = `${TELSA.apiHost}views/edit`;
            return this.$http.post(route, {args: {view: this.selectedIssueView, old_view_name: this.selectedIssueView.view_name}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },
        saveNewView: function(newView) {
            TELSA.loading(true);
            this.showViewsFavsDetails = false;

            // If they set this new view as the new default, then we have to unset the old one.
            if(newView.viewDefault) {
                for(let view of this.issueViews) {
                    view.default = false;
                }    
            }
            this.selectedIssueView = {
                user_id: this.$store.state.user.user_id,
                view_type: 'issue',
                view_name: newView.viewName,
                view_device_type: this.$store.state.user.device_type,
                view_public: newView.viewPublic,
                view_grid_config: {
                    gridData: this.gridOptions.columnApi.getColumnState(),
                    filterData: this.gridOptions.api.getFilterModel(),
                    sortData: this.gridOptions.api.getSortModel(),
                    issuesDrawer: this.issuesDrawer,
                    gridSmallMode: this.gridSmallMode
                },
                fav: true,
                default: newView.viewDefault
            };
            this.issueViews.push(this.selectedIssueView);
            this.issueViews.sort((a,b) => (a.view_name.toLowerCase() > b.view_name.toLowerCase()) ? 1 : ((b.view_name.toLowerCase() > a.view_name.toLowerCase()) ? -1 : 0));
            let route = `${TELSA.apiHost}views/add`;
            return this.$http.post(route, {args: {view: this.selectedIssueView}}).then(response => {
                let result = response.body;
                this.saveViewsFavs();
            });
        },
        saveViewsFavs: function() {
            let issueViewsFavs = [];
            for(let view of this.issueViews) {
                if(view.fav) {
                    issueViewsFavs.push({
                        user_id: view.user_id,
                        view_name: view.view_name,
                        default: view.default
                    });
                }
            }

            let route = `${TELSA.apiHost}views/favs`;
            return this.$http.post(route, {args: {view_type: 'issue', views_favs: issueViewsFavs}}).then(response => {
                let result = response.body;
                TELSA.loading(false);
            });
        },
        handleViewDelete: function(view) {
            if(view == this.selectedIssueView) {
                this.selectedIssueView = null;
            }
        },

        getSites() {
            let route = `${TELSA.apiHost}issues/sites`;
            return this.$http.get(route).then(response => {
                let results = response.body;
                this.resources.sites = results;
            });
        },

        getInitialIssuesList() {
            this.issuesList = this.$store.state.issuesList;
            this.buildAgGrid();
            this.updateIssuesRefreshTime('initial load');
        },

        refreshIssuesList: function(refreshMethod) {
            if(this.daysClosed > 0) {
                console.log('getting issues in component');
                TELSA.loading(true);
                let route = (TELSA.apiHost + "issues/list");
                this.$http.post(route, {args: {daysClosed: this.daysClosed, getNetsuiteStatuses: this.$store.state.batchConfig.webapp_netsuite}}).then(response => {
                    let results = response.body;
                    console.log('results: ', results);
                    this.issuesList = results;
                    this.gridApi.setRowData(this.issuesList);
                    this.gridApi.redrawRows();
                    this.updateIssuesRefreshTime(refreshMethod);
                    TELSA.loading(false);
                })
            }
            else {
                console.log('getting issues in store');
                if(refreshMethod == 'user request') {
                    TELSA.loading(true);  
                }
                this.$store.dispatch('getCurrentIssues').then(r => {
                    this.updateIssuesRefreshTime(refreshMethod);
                    TELSA.loading(false);
                });
            }
        },

        updateIssuesRefreshTime: function(refreshMethod) {
            this.issuesRefreshTime = TELSA.moment.tz(this.$store.state.batchConfig.timezone);
            this.issuesRefreshText = `Issues refreshed at ${this.issuesRefreshTime.format('HH:mm:ss')} (${refreshMethod})`;
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.issuesList;

            // This is telling aggrid how to apply updates
            this.gridOptions.deltaRowDataMode = true;
            this.gridOptions.getRowNodeId = function(data) {
                return data.issue_id;
            }

            this.gridOptions.columnDefs = this.createColumnDefs();

            this.gridOptions.suppressCellSelection = true

            this.getRowHeight = function(params) {
                return (self.gridSmallMode ? 24 : 40);
            };

            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                self.gridOptions.api.sizeColumnsToFit();
                self.defaultColumnState = self.gridOptions.columnApi.getColumnState();
                self.gridApi = self.gridOptions.api;
                //self.getGridConfig();
                self.applyGridConfig();
            }

            this.gridOptions.onCellContextMenu = function(params) {
                if(params.node && params.node.group) {
                    self.gridApi.hidePopupMenu();
                    return;
                }
                params.node.setSelected(true, (self.selectedRows.length <= 1));
            }
            this.gridOptions.getContextMenuItems = function(params) {
                return [
                    {
                        name: 'Details',
                        disabled: (self.selectedRows.length != 1),
                        action: function() {
                            self.issueDetails();
                        }
                    },
                    {
                        name: 'Close',
                        disabled: (self.selectedRows.length < 1),
                        action: function() {
                            self.closeIssuesClick();
                        }
                    },
                    {
                        name: 'Add Remark',
                        disabled: (self.selectedRows.length != 1),
                        action: function() {
                            self.addRemarkClick();
                        }
                    },
                    {
                        name: 'Schedule',
                        disabled: (self.selectedRows.length != 1),
                        action: function() {
                            self.createRecurringIssue();
                        }
                    },
                    'separator',
                    'csvExport',
                    'excelExport',,
                    {
                        name: 'AI Analyser',
                        disabled: !self.$store.state.batchConfig.webapp_openai,
                        action: function() {
                            self.$store.commit('setAiAnalyzerContext', 'issues');
                            self.$store.commit('setAiAnalyzerGridAPI', self.gridOptions.api);
                            self.$store.commit('setShowAIAnalyzer', true);
                        },
                        icon: `<i data-v-10101010101="" aria-hidden="true" class="v-icon notranslate mdi mdi-lightning-bolt theme--dark"></i>`
                    },
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            };

            // Set the row colors based on alarm severity
            this.gridOptions.getRowStyle = function(params) {
                if(!params.data) {
                    // This means that the row is a grouped row. Lets examine the leaf children and find the highest priority to color it.
                    //return rowColorFuncs.getGroupRowColor(params.node.allLeafChildren, self.$store.state.batchConfig.webapp_settings.alarms.alarmColors);
                    if(self.$store.state.batchConfig.webapp_settings.issues.issuesColors.useAlarmColors) {
                        return rowColorFuncs.getIssueGroupRowColor(params.node.allLeafChildren, self.$store.state.batchConfig.webapp_settings.alarms.alarmColors);
                    }
                    else {
                        return rowColorFuncs.getIssueGroupRowColor(params.node.allLeafChildren, self.$store.state.batchConfig.webapp_settings.issues.issuesColors);
                    }
                }
                if(self.$store.state.batchConfig.webapp_settings.issues.issuesColors.useAlarmColors) {
                    return rowColorFuncs.getIssueRowColor(params, self.$store.state.batchConfig.webapp_settings.alarms.alarmColors);
                }
                else {
                    return rowColorFuncs.getIssueRowColor(params, self.$store.state.batchConfig.webapp_settings.issues.issuesColors);
                }
                
            };

            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: 'Issue #', 
                    field: 'issue_id', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Title', 
                    field: 'issue_title', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Office', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        let offices = [...new Set(params.data.site_office)];
                        if(offices.length) {
                            return (offices.length == 1 ? offices[0] : '[multiple]');
                        }
                        return '';
                    },
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Location', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        let locations = [...new Set(params.data.site_location)];
                        if(locations.length) {
                            return (locations.length == 1 ? locations[0] : '[multiple]');
                        }
                        return '';
                    },
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Description', 
                    field: 'issue_description', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Revised', 
                    field: 'issue_revised_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: issueDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Category', 
                    field: 'issue_category', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: (self.resources.categories.concat(['[Unassigned]']))
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Service', 
                    field: 'issue_services', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Cause', 
                    field: 'issue_cause', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: (self.resources.causes.concat(['[Unassigned]']))
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Status', 
                    field: 'issue_status', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: self.statusList
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Dup Of', 
                    field: 'issue_duplicate_id', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Priority', 
                    field: 'issue_priority', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: self.priorityList
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Severity', 
                    field: 'issue_severity', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: self.severityList
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Started', 
                    field: 'issue_start_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: issueDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Update Due', 
                    field: 'issue_update_due', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        return params.data.issue_update_due ? `Every ${params.data.issue_update_due} hours` : `Never`;
                    },
                },
                { 
                    headerName: 'Issue Due', 
                    field: 'issue_due_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: issueDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Owner', 
                    field: 'issue_owner', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Mins Affected', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                    },
                },
                { 
                    headerName: 'Min Type', 
                    field: 'issue_affected_type', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: self.affectedList
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'FCC Status', 
                    field: 'issue_fcc_status', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Solution', 
                    field: 'issue_solution', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Opened By', 
                    field: 'issue_open_user', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Opened', 
                    field: 'issue_open_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: issueDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Solved', 
                    field: 'issue_solve_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: issueDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Closed By', 
                    field: 'issue_close_user', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Closed', 
                    field: 'issue_close_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: issueDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        return params.data.issue_close_time ? TELSA.moment(params.data.issue_close_time).format('YYYY-MM-DD HH:mm:ss') : '';
                    }
                },
                { 
                    headerName: 'Auto-Close', 
                    field: 'issue_autoclose_time', 
                    width: 150, 
                    filter: 'agDateColumnFilter',
                    filterParams: issueDateFilterParams,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                },
                { 
                    headerName: 'Technician', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: (self.technicianOptions.concat(['[multiple]', null]))
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        let technicians = [...new Set(params.data.user_username)];
                        if(technicians.length) {
                            return (technicians.length == 1 ? technicians[0] : '[multiple]');
                        }
                        return '';
                    },
                },
                { 
                    headerName: 'Site Name', 
                    field: 'alarm_location', 
                    width: 150, 
                    filter: 'text', 
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Locale', 
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: (self.localeOptions.concat(['[multiple]', null]))
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        let locales = [...new Set(params.data.site_locale)];
                        if(locales.length) {
                            return (locales.length == 1 ? locales[0] : '[multiple]');
                        }
                        return '';
                    },
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Tags', 
                    field: 'issue_tags',
                    width: 150, 
                    filter: 'agSetColumnFilter',
                    filterParams: {
                        values: (self.issueTagOptions.concat(null))
                    },
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(!params.data) {
                            return;
                        }
                        if(!params.data.issue_tags.length) {
                            return '';
                        }
                        return params.data.issue_tags.map(t => {
                            let mtag = self.resources.issue_tags.find(tag => tag.issue_tag_id == t);
                            return mtag ? mtag.issue_tag_name : '';
                        });
                    },
                    enableRowGroup: true,
                },
                { 
                    headerName: 'Transfer Order ID', 
                    field: 'transfer_order_id', 
                    headerComponentParams: { menuIcon: "mdi-sticker" },
                    width: 150, 
                    filter: 'text', 
                    suppressColumnsToolPanel: !self.$store.state.batchConfig.webapp_netsuite,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(params.data.netsuite_transfer_order_ids && params.data.netsuite_transfer_order_ids.length) {
                            return params.data.netsuite_transfer_order_ids.length > 1 ? params.data.netsuite_transfer_order_ids.join(',') : params.data.netsuite_transfer_order_ids[0];
                        }
                        return "";
                    }
                },
                { 
                    headerName: 'Transfer Order Document Number', 
                    field: 'transfer_order_document_number', 
                    headerComponentParams: { menuIcon: "mdi-sticker" },
                    width: 150, 
                    filter: 'text', 
                    suppressColumnsToolPanel: !self.$store.state.batchConfig.webapp_netsuite,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(params.data.netsuite_transfer_document_numbers && params.data.netsuite_transfer_document_numbers.length) {
                            return params.data.netsuite_transfer_document_numbers.length > 1 ? params.data.netsuite_transfer_document_numbers.join(',') : params.data.netsuite_transfer_document_numbers[0];
                        }
                        return "";
                    }
                },
                { 
                    headerName: 'Transfer Order Status', 
                    field: 'transfer_order_status', 
                    width: 150, 
                    filter: 'text', 
                    suppressColumnsToolPanel: !self.$store.state.batchConfig.webapp_netsuite,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(params.data.netsuite_transfer_order_statuses && params.data.netsuite_transfer_order_statuses.length) {
                            return params.data.netsuite_transfer_order_statuses.length > 1 ? params.data.netsuite_transfer_order_statuses.join(',') : params.data.netsuite_transfer_order_statuses[0];
                        }
                        return "";
                    }
                },
                { 
                    headerName: 'Item Fulfillment Status', 
                    field: 'item_fulfillment_status', 
                    width: 150, 
                    filter: 'text', 
                    suppressColumnsToolPanel: !self.$store.state.batchConfig.webapp_netsuite,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(params.data.netsuite_transfer_order_item_fulfillment_statuses && params.data.netsuite_transfer_order_item_fulfillment_statuses.length) {
                            return params.data.netsuite_transfer_order_item_fulfillment_statuses.length > 1 ? params.data.netsuite_transfer_order_item_fulfillment_statuses.join(',') : params.data.netsuite_transfer_order_item_fulfillment_statuses[0];
                        }
                        return "";
                    }
                },
                { 
                    headerName: 'Shipping Carrier', 
                    field: 'shipping_carrier', 
                    width: 150, 
                    filter: 'text', 
                    suppressColumnsToolPanel: !self.$store.state.batchConfig.webapp_netsuite,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(params.data.netsuite_transfer_order_shipping_carriers && params.data.netsuite_transfer_order_shipping_carriers.length) {
                            return params.data.netsuite_transfer_order_shipping_carriers.length > 1 ? params.data.netsuite_transfer_order_shipping_carriers.join(',') : params.data.netsuite_transfer_order_shipping_carriers[0];
                        }
                        return "";
                    }
                },
                { 
                    headerName: 'Tracking Number', 
                    field: 'tracking_number', 
                    width: 150, 
                    filter: 'text', 
                    suppressColumnsToolPanel: !self.$store.state.batchConfig.webapp_netsuite,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            if(params.data.netsuite_transfer_order_tracking_numbers && params.data.netsuite_transfer_order_tracking_numbers.length) {
                                if(params.data.netsuite_transfer_order_tracking_numbers.length > 1) {
                                    this.eGui.innerHTML = `<span>multiple</span>`;
                                }
                                else {
                                    this.eGui.innerHTML = `<span class="to-tracking-number">${params.data.netsuite_transfer_order_tracking_numbers[0]}</span>`;
                                    this.trackingLink = this.eGui.querySelectorAll('.to-tracking-number')[0];
                                    this.linkClickHandler = this.linkClickHandler.bind(this);
                                    this.trackingLink.addEventListener('click', this.linkClickHandler);
                                }
                            }
                            else {
                                this.eGui.innerHTML = '';
                            }
                        }
                        getGui() {
                            return this.eGui;
                        }
                        linkClickHandler(event) {
                            // Double check we only got 1
                            if(this.params.data && this.params.data.netsuite_transfer_order_tracking_numbers && this.params.data.netsuite_transfer_order_tracking_numbers.length == 1
                                && this.params.data.netsuite_transfer_order_shipping_carriers && this.params.data.netsuite_transfer_order_shipping_carriers.length == 1) {
                                let shippingService = this.params.data.netsuite_transfer_order_shipping_carriers[0];
                                let trackingNumber = this.params.data.netsuite_transfer_order_tracking_numbers[0];
                                console.log(`${shippingService}: ${trackingNumber}`);
                                if(shippingService.toUpperCase() == 'DHL') {
                                    window.open(`https://www.dhl.com/us-en/home/tracking/tracking-express.html?submit=1&tracking-id=${trackingNumber.replace(/\s+/g, '')}`, "_blank");
                                }
                                else if(shippingService.toUpperCase() == 'FEDERAL EXPRESS') {
                                    window.open(`https://www.fedex.com/fedextrack/?trknbr=${trackingNumber.replace(/\s+/g, '')}`, "_blank");
                                }
                                else if(shippingService.toUpperCase() == 'DSV AIR & SEA') {
                                    window.open(`https://mydsv.com/track-shipment?query=${trackingNumber.replace(/\s+/g, '')}`, "_blank");
                                }
                                else if(shippingService.toUpperCase() == 'SUNSHINE STATE MESSENGER') {
                                    window.open(`https://sunshinedelivers.com/`, "_blank");
                                }
                                else if(shippingService.toUpperCase() == 'UPS') {
                                    window.open(`https://ups.com/track?loc=en_US&requester=QUIC&tracknum=${trackingNumber.replace(/\s+/g, '')}`, "_blank");
                                }
                                else if(shippingService.toUpperCase() == 'VESSEL LOGISTICS PROVIDER') {
                                    // This is just a place holder
                                }
                            }
                        }
                        destroy() {
                            if(this.trackingLink) {
                                this.trackingLink.removeEventListener('click', this.linkClickHandler);
                            }
                        }
                    },
                },
                { 
                    headerName: 'Scheduled Delivery Date', 
                    field: 'scheduled_delivery_date', 
                    width: 150, 
                    filter: 'text', 
                    suppressColumnsToolPanel: !self.$store.state.batchConfig.webapp_netsuite,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(params.data.netsuite_transfer_order_scheduled_delivery_dates && params.data.netsuite_transfer_order_scheduled_delivery_dates.length) {
                            return params.data.netsuite_transfer_order_scheduled_delivery_dates.length > 1 ? params.data.netsuite_transfer_order_scheduled_delivery_dates.join(',') : params.data.netsuite_transfer_order_scheduled_delivery_dates[0];
                        }
                        return "";
                    }
                },
                {
                    headerName: 'Item Receipt Memo', 
                    field: 'item_receipt_memo', 
                    width: 150, 
                    filter: 'text', 
                    suppressColumnsToolPanel: !self.$store.state.batchConfig.webapp_netsuite,
                    cellStyle: params => ({'padding-top': `${self.gridRowPadding}`, 'text-align': 'left'}),
                    valueGetter: function(params) {
                        if(params.data.netsuite_transfer_order_item_receipt_memos && params.data.netsuite_transfer_order_item_receipt_memos.length) {
                            return params.data.netsuite_transfer_order_item_receipt_memos.length > 1 ? params.data.netsuite_transfer_order_item_receipt_memos.join(',') : params.data.netsuite_transfer_order_item_receipt_memos[0];
                        }
                        return "";
                    }
                },
            ];
            return columnDefs;
        },

        applyGridConfig: function() {
            // Are they coming from the issue tray?
            if(this.$store.state.issueTrayFilter) {
                this.gridOptions.api.setFilterModel({issue_severity: {filterType: 'set', values: [this.issueTrayFilter.toUpperCase()]}});
                this.$store.commit('setIssueTrayFilter', null);
                TELSA.loading(false);
                return;
            }
            
            // If there is no issue view then we're done.
            if(this.selectedIssueView) {
                this.gridOptions.columnApi.setColumnState(this.selectedIssueView.view_grid_config.gridData);
                this.gridOptions.api.setFilterModel(this.selectedIssueView.view_grid_config.filterData);
                this.gridOptions.api.setSortModel(this.selectedIssueView.view_grid_config.sortData);
                this.issuesDrawer = this.selectedIssueView.view_grid_config.issuesDrawer ? this.selectedIssueView.view_grid_config.issuesDrawer : false;

                let issueDrawerWidthPct = this.selectedIssueView.view_grid_config.issueDrawerWidthPct;
                let issueDrawerWidth = issueDrawerWidthPct ? parseFloat((issueDrawerWidthPct * document.getElementById('telsasoft-application').offsetWidth).toFixed(2)) : 256;
                document.getElementById('issues-drawer').style.width = `${issueDrawerWidth}px`;
                if(this.issuesDrawer) {
                    document.getElementById('ag-grid-issues-container').style.width = `calc(100% - ${issueDrawerWidth}px)`;
                }

                this.gridSmallMode = this.selectedIssueView.view_grid_config.gridSmallMode ? this.selectedIssueView.view_grid_config.gridSmallMode : false;
            }
            // we need to trigger the UI to change to compact/comfortable mode.
            this.gridApi.resetRowHeights();
            this.gridApi.redrawRows();
            TELSA.loading(false);
        },

        exportToExcelFile: function() {
            let params = {
                fileName: `${this.current ? 'Current' : 'Hostorical'}Issues_${TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('MMM_DD_YYYY')}`,
                sheetName: 'data'
            }
            this.gridOptions.api.exportDataAsExcel(params);
        },
        exportToCsvFile: function() {
            let params = {
                fileName: `${this.current ? 'Current' : 'Hostorical'}Issues_${TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('MMM_DD_YYYY')}`,
                sheetName: 'data'
            }
            this.gridOptions.api.exportDataAsCsv(params);
        },

        issuesDrawerToggle: function() {
            this.issuesDrawer = !this.issuesDrawer;
            if(this.issuesDrawer) {
                let drawerWidth = document.getElementById('issues-drawer').offsetWidth;
                document.getElementById('ag-grid-issues-container').style.width = `calc(100% - ${drawerWidth}px)`;
            }
            else {
                document.getElementById('ag-grid-issues-container').style.width = '100%';
            }

        },

        onRowSelectionChanged: function() {
            this.selectedRows = this.gridOptions.api.getSelectedRows();

            if(this.selectedRows.length === 1) {
                let issue = this.selectedRows[0];
                let route = (TELSA.apiHost + "issues/historyremarks");
                this.$http.post(route, {args: {issueIds: [issue.issue_id]}}).then(response => {
                    let historyremarks = response.data[0];
                    issue.issue_history = historyremarks.history;
                    issue.issue_remarks = historyremarks.remarks;
                    this.selectedRows.splice(0,0); // trigger the action drawer props to re-run computeds
                });
            }
        },

        issueDetails: function() {
            this.selectedRows = this.gridOptions.api.getSelectedRows();
            this.selectedIssue = this.selectedRows[0];
            this.selectedIssueType = 'edit';
            let promises = [];
            let filesRoute = `${TELSA.apiHost}issues/files/${this.selectedIssue.issue_id}`;
            let alarmRoute = `${TELSA.apiHost}alarms/details`;
            let alarmDetailsPromise = this.selectedIssue.alarm_id ? (this.$http.post(alarmRoute, {args: {alarmId: this.selectedIssue.alarm_id}}).then(r => {this.selectedIssue.alarmDetails = r.body.original})) : Promise.resolve();
            promises.push(alarmDetailsPromise);
            promises.push(this.$http.get(filesRoute).then(response => {this.selectedIssue.files = response.body}));
            // format times without mili-seconds
            this.selectedIssue.issue_start_time = this.selectedIssue.issue_start_time ? TELSA.moment(this.selectedIssue.issue_start_time).format('YYYY-MM-DD HH:mm:ss') : "";
            this.selectedIssue.issue_due_time = this.selectedIssue.issue_due_time ? TELSA.moment(this.selectedIssue.issue_due_time).format('YYYY-MM-DD HH:mm:ss') : "";
            this.selectedIssue.issue_solve_time = this.selectedIssue.issue_solve_time ? TELSA.moment(this.selectedIssue.issue_solve_time).format('YYYY-MM-DD HH:mm:ss') : "";
            this.selectedIssue.issue_autoclose_time = this.selectedIssue.issue_autoclose_time ? TELSA.moment(this.selectedIssue.issue_autoclose_time).format('YYYY-MM-DD HH:mm:ss') : "";
            TELSA.loading(true);
            Promise.all(promises).then(res => {
                this.showIssueDetails = true;
                TELSA.loading(false);
            });
        },

        addRemarkClick: function() {
            if(!TELSA.checkPermission(this.$store.state.user, 'issue/revise')) {
                this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>revise</b> issues.`});
            }
            else {
                this.addRemarkId = this.gridOptions.api.getSelectedRows()[0].issue_id
                this.showAddRemark = true;
            }
        },

        addRemark: function(remark) {
            TELSA.loading(true);
            let route = `${TELSA.apiHost}issues/remarks/add`;
            return this.$http.post(route, {args: {issueId: this.addRemarkId, remark: remark}}).then(response => {
                this.addRemarkId = null;
                this.showAddRemark = false;
                TELSA.loading(false);
            });
        },

        createRecurringIssue: function() {
            this.recurringIssueIssue = this.gridOptions.api.getSelectedRows()[0];
            this.showRecurringIssues = true;
        },

        closeIssuesClick: function() {
            if(!(TELSA.checkPermission(this.$store.state.user, 'issue/revise') && TELSA.checkPermission(this.$store.state.user, 'issue/close'))) {
                this.$store.commit('insufficientPermissions', {message: `You do not have permission to <b>revise and close</b> issues.`});
            }
            else {
                let plural = this.selectedRows.length > 1 ? 's' : '';
                this.$store.commit('showConfirmModal', {
                    title: `Issue${plural} Closing Confirmation`,
                    message: `Are you sure you want to close the selected issue${plural}? The issue solution field${plural} will be left blank if not already filled out.
                                You can edit the issue${plural} by going to the issue detail window.`,
                    type: '',
                    hideCancel: false,
                    confirmAction: () => this.closeIssues(this.selectedRows)
                });
            }
        },

        closeIssues: function(issues) {
            TELSA.loading(true);
            let route = `${TELSA.apiHost}issues/save`;
            let self = this;
            let index = 0;

            // Remove issues that are already closed
            issues = issues.filter(issue => {
                return issue.issue_status != 'Closed';
            });

            let lockAndSave = (issue) => {    
                //issue.issue_history = `[${this.$store.state.user.user_username} at ${TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD HH:mm:ss')}] changed Status from "${issue.issue_status}" to "Closed" \n` + issue.issue_history;
                let ts = TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD HH:mm:ss');
                issue.issue_history.push({user: this.$store.state.user.user_username, ts: ts, issue_action_details: `changed Status from "${issue.issue_status}" to "Closed"` })

                issue.issue_status = 'Closed';
                issue.issue_close_user = this.$store.state.user.user_username;
                issue.issue_close_time = TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD HH:mm:ss');

                let lockName = `edit_issue/${issue.issue_id}`;
                self.$store.dispatch('getLock', lockName).then(lockOwner => {
                    if(lockOwner) {
                        // Let the user know that this particular issue is already locked and that we cannot close it.
                        self.lockSave = true;
                        self.$store.commit('showConfirmModal', {
                            title: 'Lock Warning',
                            message: `The Issue (#${issue.issue_id}) is already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot close it at this time.`,
                            type: 'warning',
                            hideCancel: true,
                            confirmAction: function(){}
                        });
                        index++;
                        if(index < issues.length) {
                            lockAndSave(issues[index]);
                        }
                        else {
                            TELSA.loading(false);
                        }
                    }
                    else {
                        self.$http.post(route, {args: {lock: self.$store.state.lock, issue: issue}}).then(response => {
                            let files = response.body;
                            self.$store.dispatch('handleRemoveLocks').then(response => {
                                index++;
                                if(index < issues.length) {
                                    lockAndSave(issues[index]);
                                }
                                else {
                                    TELSA.loading(false);
                                }
                            });
                        });
                    }
                });
            };

            if(issues.length) {
                lockAndSave(issues[index]);
            }
            else {
                TELSA.loading(false);
            }
        },

        createNewIssueFromTemplate: function(templateName) {
            // Permissions Check 
            let permission = TELSA.checkPermission(this.$store.state.user, 'issue/create');
            if(!permission) {
                this.$store.commit('insufficientPermissions', {message: `You do not have permission to create new issues.`});
                return;
            }
            
            TELSA.loading(true);
            let route = `${TELSA.apiHost}issues/templates/template`;
            return this.$http.post(route, {args: {templateName: templateName}}).then(response => {
                let template = response.body;
                console.log('template', template);
                this.showIssueTemplates = false;
                this.createNewIssue(template);
            });
        },

        createNewIssue: function(template) {
            this.createNewIssueFromTemplateName = template ? template.name : null;
            template = template ? template.issue : null;
            // Permissions Check 
            let permission = TELSA.checkPermission(this.$store.state.user, 'issue/create');
            if(!permission) {
                this.$store.commit('insufficientPermissions', {message: `You do not have permission to create new issues.`});
                return;
            }
            console.log('createNewIssue: ', template);
            TELSA.loading(true);
            let route = `${TELSA.apiHost}issues/new`;
            return this.$http.get(route).then(response => {
                let newIssueId = response.body;
                this.selectedIssue = {
                    alarm_full_text: template ? template.alarm_full_text : "",
                    alarm_id: template ? template.alarm_id : 0,
                    files: [],
                    issue_affected: template ? template.issue_affected : 0,
                    issue_affected_type: template ? template.issue_affected_type : "Users",
                    issue_autoclose_time: "",
                    issue_category: template ? template.issue_category : "[Unassigned]",
                    issue_cause: template ? template.issue_cause : "[Unassigned]",
                    issue_close_time: null,
                    issue_close_user: null,
                    issue_description: template ? template.issue_description : "",
                    issue_due_time: TELSA.moment.tz(this.$store.state.batchConfig.timezone).add(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    issue_duplicate_id: template ? template.issue_duplicate_id : 0,
                    issue_fcc_status: template ? template.issue_fcc_status : "[not reportable]",
                    issue_history: [],
                    issue_id: newIssueId,
                    issue_ip_members: template ? template.issue_ip_members : "",
                    issue_ip_options: template ? template.issue_ip_options : "0;0",
                    issue_open_time: null, // This will be set to now() upon save
                    issue_open_user: this.$store.state.user.user_username,
                    issue_options: template ? template.issue_options : "0;0",
                    issue_owner: template ? (template.issue_owner == "alarm_site_technician" ? '' : template.issue_owner) : this.$store.state.user.user_username,
                    issue_priority: template ? template.issue_priority : "Normal",
                    issue_remarks: template ? template.issue_remarks : [],
                    issue_revised_time: null, // This will be set to now() upon save
                    issue_services: template ? template.issue_services : "",
                    issue_severity: template ? template.issue_severity : "OBSERVATIONAL",
                    issue_solution: template ? template.issue_solution : "",
                    issue_solve_time: TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD HH:mm:ss'), // This will be nulled out if disabled upon save
                    issue_start_time: TELSA.moment.tz(this.$store.state.batchConfig.timezone).format('YYYY-MM-DD HH:mm:ss'),
                    issue_status: template ? template.issue_status : "Open",
                    issue_title: template ? template.issue_title : "",
                    issue_update_due: template ? template.issue_update_due : 0,
                    issue_tags: template ? template.issue_tags : [],
                    site_id: template ? template.site_id : [],
                    site_locale: template ? template.site_locale : [],
                    site_location: template ? template.site_location : [],
                    site_name: template ? template.site_name : [],
                    site_office: template ? template.site_office : [],
                    user_username: template ? template.user_username : [],
                };
                // If they're creating the issue from an alarm then lets set those fields now
                if(this.$store.state.createIssueFromAlarmShortcut) {
                    let alarm = this.$store.state.createIssueFromAlarmShortcut.alarm;
                    this.selectedIssue.alarm_full_text = `${alarm.alarm_details.text}`;
                    //this.selectedIssue.alarm_history = alarm.alarm_history;
                    this.selectedIssue.alarm_id = alarm.alarm_id;
                    //this.selectedIssue.alarm_remarks = alarm.alarm_remarks;
                    this.selectedIssue.issue_start_time = alarm.alarm_time;
                    this.selectedIssue.issue_severity = alarm.alarm_severity;

                    if(alarm.alarm_site_id) {
                        this.selectedIssue.site_id = [alarm.alarm_site_id];
                        this.selectedIssue.site_locale = [alarm.site_locale];
                        this.selectedIssue.site_location = [alarm.alarm_location];
                        this.selectedIssue.site_name = [alarm.site_name];
                        this.selectedIssue.site_office = [alarm.alarm_office];
                        if(template && template.issue_owner == "alarm_site_technician" && alarm.user_username) {
                            this.selectedIssue.issue_owner = alarm.user_username;
                        }
                    }
                    // Reset this back to null now that we're donw with it. 
                    //this.$store.commit('setCreateIssueFromAlarmShortcut', null);
                }

                this.selectedIssueType = 'new';
                this.showIssueDetails = true;
                TELSA.loading(false);
            });
        },

        closeIssueDetails: function() {
            this.showIssueDetails = false;
            this.selectedIssue = null;
            this.selectedIssueType = null;
            if(this.$store.state.createIssueFromAlarmShortcut) {
                // Reset this back to null now that we're donw with it. 
                this.$store.commit('setCreateIssueFromAlarmShortcut', null);
                this.$router.push('alarms');
            }
        },

        setupAutoPolling: function() {
            let self = this;
            const fiveMin = 300000;
            this.pollCheck = setInterval(function() {
                if(((TELSA.moment.tz(self.$store.state.batchConfig.timezone) - self.issuesRefreshTime) > fiveMin) && self.current) {
                    self.refreshIssuesList('polled');
                    self.issuesRefreshTime = TELSA.moment.tz(self.$store.state.batchConfig.timezone);
                }
            }, 5000);
        },

        runHistoricalIssues: function(params) {
            TELSA.loading(true);
            params.startDateTime = TELSA.moment(params.startDateTime).format('YYYY-MM-DD HH:mm:ss');
            params.endDateTime = TELSA.moment(params.endDateTime).format('YYYY-MM-DD HH:mm:ss');
            this.showHistoricalParams = false;
            this.historicalIssuesParams = params;
            this.issuesMode = 'historical';
            let route = (TELSA.apiHost + "issues/historical");
            return this.$http.post(route, {args: {params: params}}).then(response => {
                let result = response.body;
                this.issuesList = result;
                this.gridApi.setRowData(this.issuesList);
                this.applyGridConfig();
            });
        },

        currentIssuesClick: function() {
            this.issuesMode = 'current';
            this.refreshIssuesList('user request');
        },

        handleUpdateIssues: function(updatedIssues) {
            console.log('updatedIssues in function', updatedIssues);
            let found = false;
            for(let updatedIssue of updatedIssues) {
                found = false;
                for(let [i, issue] of this.issuesList.entries()) {
                    if(updatedIssue.issue_id == issue.issue_id) {
                        found = true;
                        // Need to check if the new one has been closed. If it has, then we need to check when it was closed in relation to the "Days Closed" value
                        if(updatedIssue.issue_close_time && (TELSA.moment(updatedIssue.issue_close_time) < TELSA.moment.tz(this.$store.state.batchConfig.timezone).subtract(this.daysClosed, 'days'))) {
                            // This issue should actually be removed because the closed time is now outside the "Days Closed" filter
                            this.issuesList.splice(i, 1);
                        }
                        else {
                            this.issuesList[i] = updatedIssue;
                        }
                        break;
                    }
                }
                if(!found) {
                    // The only way the updated issue would not be found is if it was originally closed but now has been reopened. So we just add it like we would with a new issue.
                    this.issuesList.push(updatedIssue);
                }
            }
            this.gridApi.setRowData(this.issuesList);
            this.updateIssuesRefreshTime('delta');
        },

        handleNewIssues: function(newIssues) {
            for(let newIssue of newIssues) {
                if(newIssue.issue_close_time && (TELSA.moment(updatedIssue.issue_close_time) < TELSA.moment.tz(this.$store.state.batchConfig.timezone).subtract(this.daysClosed, 'days'))) {
                    // The new issue is closed and closed date is outsite the "Days Closed" filter so we do NOT add it.
                }
                else {
                    this.issuesList.push(newIssue);
                }
            }

            this.gridApi.setRowData(this.issuesList);
            this.updateIssuesRefreshTime('delta');
        },

        toggleFullscreen: function() {
            document.getElementById('ag-grid-issues-container-fullscreen').webkitRequestFullscreen();
        },

        toggleGridSmallMode: function() {
            this.gridSmallMode = !this.gridSmallMode;
            this.gridApi.resetRowHeights();
            this.gridApi.redrawRows();
        },

        sendToClipboard: function(params) {
            if(!this.selectedRows.length) {
                return;
            }
            let clipboardText = '';
            for(let [idx, row] of this.selectedRows.entries()) {
                clipboardText += `Issue Details:\n`;
                clipboardText += `\tDescription:  ${row.issue_description}\n`;
                clipboardText += `\tLocation:     ${row.site_location.length ? row.site_location[0] : ''}\n`;
                clipboardText += `\tOffice:       ${row.site_office.length ? row.site_office[0] : ''}\n`;
                clipboardText += `\tTime:         ${row.issue_start_time}\n`;
                clipboardText += `\tCategory:     ${row.issue_category}\n`;
                clipboardText += `\tServices:     ${row.issue_services}\n`;
                clipboardText += `\tCause:        ${row.issue_cause}\n`;
                clipboardText += `\tStatus:       ${row.issue_status}\n`;
                clipboardText += `\tOwner:        ${row.issue_owner}\n`;
                clipboardText += `\tAffected:     ${row.issue_affected} ${row.issue_affected_type}\n`;

                clipboardText += `Remarks:\n`;
                clipboardText += `\t${row.issue_remarks.replace(/\n/g, '\n\t')}\n`;
                clipboardText += `History:\n`;
                clipboardText += `\t${row.issue_history.replace(/\n/g, '\n\t')}`;

                if(idx != (this.selectedRows.length - 1)) {
                    clipboardText += "\n------------------------------------------\n\n";
                }
            }

            navigator.clipboard.writeText(clipboardText);
        },

        showViewManagementClick: function() {
            let obj = {
                gridData: this.gridOptions.columnApi.getColumnState(),
                filterData: this.gridOptions.api.getFilterModel(),
                sortData: this.gridOptions.api.getSortModel(),
                issuesDrawer: this.issuesDrawer,
                gridSmallMode: this.gridSmallMode
            }
            this.currentViewGridConfig = obj;
            this.showViewManagement = true;
        },

        clearView: function() {
            this.gridOptions.columnApi.setColumnState(this.defaultColumnState);
            this.gridOptions.api.setFilterModel(null);
            this.gridOptions.api.setSortModel(null);
            this.selectedIssueView = null;
        },

        createIssueSubscriptions: function() {
            this.issueSubscriptionUnsubscribeFunc = this.$store.subscribe((mutation, state) => {
                if(this.issuesMode == 'historical' || this.daysClosed > 0 || !this.gridApi) {
                    if(this.issuesMode == 'historical'){console.log('UPDATE BUT NOT VIEWING CURRENT.');}
                    if(this.daysClosed > 0){console.log('UPDATE BUT VIEWING DAYS CLOSED');}
                    return;
                }

                if(mutation.type === 'SOCKET_ISSUES_NEW' || mutation.type === 'SOCKET_ISSUES_UPDATE') {
                    console.log('ISSUES SUB: ', mutation);
                    let selectedRowHash = (this.selectedRows.length && this.selectedRows.length === 1) ? TELSA.hash(this.selectedRows[0]) : null;
                    this.issuesList = state.issuesList;
                    this.gridApi.setRowData(this.issuesList);
                    this.gridApi.redrawRows();
                    this.updateIssuesRefreshTime('delta');

                    // if they have just 1 issue selected then go get updated history
                    try {
                        if(selectedRowHash && selectedRowHash != TELSA.hash(this.gridOptions.api.getSelectedRows()[0])) {
                            this.onRowSelectionChanged();
                        }
                    } catch(e) {}
                }
                else if(mutation.type === 'setIssuesList') {
                    console.log('POLLED ISSUES SUB');
                    this.issuesList = state.issuesList;
                    this.gridApi.setRowData(this.issuesList);
                    this.gridApi.redrawRows();
                    this.updateIssuesRefreshTime('polled');
                }
            }, {prepend: false});
        },


    },


    // ONLY USED FOR WHEN THEYRE LOOKING AT DAYS CLOSED > 0
    sockets: {
        ISSUES_UPDATE: function(updatedIssues) {
            // If user is looking at historical issues, or not closed issues, or gris hasn't loaded yet then don't do anything
            if(this.issuesMode == 'historical' || this.daysClosed == 0 || !this.gridApi) {
                return;
            }
            //console.log('OLD IN COMPONENT updatedIssues', updatedIssues);
            this.handleUpdateIssues(updatedIssues);
        },
        ISSUES_NEW: function(newIssues) {
            // If user is looking at historical issues, or not closed issues, or gris hasn't loaded yet then don't do anything
            if(this.issuesMode == 'historical' || this.daysClosed == 0 || !this.gridApi) {
                return;
            }
            //console.log('OLD IN COMPONENT newIssues', newIssues);
            this.handleNewIssues(newIssues);
        },
    },

    mounted() {
        // If they don't have a license for issues then dont start anything.
        if(!this.$store.state.batchConfig.webapp_issues) {
            return;
        }

        this.issuesRefreshTime = TELSA.moment.tz(this.$store.state.batchConfig.timezone);

        let promises = [];
        promises.push(this.getResources());
        promises.push(this.getSetFilterResources());
        promises.push(this.getIssueViews());
        promises.push(this.getSites());
        Promise.all(promises).then(res => {
            this.getInitialIssuesList();
            this.setupAutoPolling();
            this.createIssueSubscriptions();
            // Check if they came here from alarms and want to create a new issue with prefilled alarm info
            if(this.$store.state.createIssueFromAlarmShortcut) {
                this.createNewIssue(this.$store.state.createIssueFromAlarmShortcut.issueTemplate ? this.$store.state.createIssueFromAlarmShortcut.issueTemplate : null);
            }
        });
    },

    destroyed() {
        // If they don't have a license for issues then theres nothing to clean up.
        if(!this.$store.state.batchConfig.webapp_issues) {
            return;
        }
        this.issueSubscriptionUnsubscribeFunc();

        clearInterval(this.pollCheck);
        this.$store.commit('setCreateIssueFromAlarmShortcut', null);
        this.$store.commit('setIssueTrayFilter', null);
    },

    watch: {
        issueTrayFilter: {
            handler(newVal, oldVal) {
                if(newVal) {
                    this.applyGridConfig();
                }
            },
        },

        widgetCommand: {
            handler(newVal, oldVal) {
                if(newVal) {
                    if(newVal.type == 'clearView') {
                        this.clearView();
                    }
                    else if(newVal.type == 'setView') {
                        this.selectedIssueView = newVal.value;
                        if(this.showGrid) {
                            this.applyGridConfig();
                        }
                    }
                    else if(newVal.type == 'setDensity') {
                        if(this.gridSmallMode != (newVal.value == 'Compact')) {
                            this.toggleGridSmallMode();
                        }
                    }
                }
            },
        }
    },

  
};
</script>

<style scoped>

    .widget-mode {
        padding: 0px !important;
    }

    .view-select-container {
        position: relative;
        display: inline-block;
        /* width: 400px; */
        margin-left: calc(40% - (350px / 1));
        text-align: center;
        height: 40px;
    }
    .view-select {
        width: 250px;
        display: inline-block;
    }
    .view-select-container .view-button {
        display: initial;
    }

    @media(max-width: 1000px) {
        .view-select-container {
            width: 350px;
            float: right;
        }
        .view-select {
            width: 200px;
        }
        .view-select-container .view-button {
            display: none;
        }
    }
    @media(max-width: 900px) {
        .view-select-container {
            width: 180px;
            float: right;
        }
        .view-select {
            width: 180px;
        }
        .view-select-container .view-button {
            display: none;
        }
    }

    .view-select-default-text {
        color: yellow;
        position: absolute;
        right: 20px;
        text-align: right;
        font-size: 11px;
        font-weight: bold;
    }

    .density-check {
        margin-left: -35px;
        margin-right: 18px;
    }

    .days-closed-container {
        margin-left: 15px;
        display: inline-block;
        position: relative;
        height: 35px;
        width: 70px;
        vertical-align: top;
        margin-top: 3px;
    }
    .days-closed-container span {
        position: absolute;
        top: -16px;
        left: 0;
        font-size: 8pt;
        color: #ffffff;
    }
    .days-closed-container input {
        position: relative;
        width: 60px;
        height: 29px;
        background-color: #ffffff;
        color: #000000;
        border-radius: 5px;
        padding: 5px;
        vertical-align: bottom;
        outline: none;
        /* border: #c42111 solid 1px; */
        font-weight: bold;
    }

    #ag-grid-issues-container-fullscreen {
        width: 100%;
        height: calc(100vh - 135px);
    }
    #ag-grid-issues-container-fullscreen.widget-mode {
        height: 100%;
    }

    #ag-grid-issues-container {
        width: 100%;
        /* transition: width 0.1s; */
        display: block;
        height: 100%;
    }
    #ag-grid-issues-container.drawer {
        max-width: calc(100% - 256px);
        /* transition: width 0.25s; */
        display: inline-block;
        float: left;
    }

    #issues-drawer {
        width: 0px;
        height: 0px;
        background-color: #ffffff;
        display: inline-block;
        /* transition: width 0.1s; */
        float: left;
    }
    #issues-drawer.active {
        width: 256px;
        height: 100%;
        /* transition: width 0.25s; */
    }

    .refresh-text {
        font-size: 10pt;
        bottom: 5px;
        left: 18px;
        position: absolute;
    }

    .row-count-text {
        font-size: 10pt;
        display: block;
        width: 200px;
        font-size: 10pt;
        bottom: 5px;
        left: calc(50% - (200px / 2));
        text-align: center;
        position: absolute;
    }

</style>

<style>
    #ag-grid-issues-container .ag-row-hover {
        /* putting in !important so it overrides the theme's styling as it hovers the row also */
        background-color: #c8e6c9 !important;
    }

    #ag-grid-issues-container .ag-row-selected {
        background-color: #0000ff !important;
        color: #ffffff !important;
    }

    #ag-grid-issues-container .ag-theme-balham .ag-icon.ag-icon-expanded {
        color: #000000;
        font-weight: bold;
        margin-top: -10px;
        font-size: 20px;
    }

    .view-select-container .v-text-field.v-text-field--outlined .v-input__control{
        min-height: 10px !important;
    }
    .view-select-container .v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: 10px !important;
    }
    .view-select-container .v-text-field.v-text-field--enclosed .v-input__prepend-outer, .v-text-field.v-text-field--enclosed .v-input__prepend-inner, .v-text-field.v-text-field--enclosed .v-input__append-inner, .v-text-field.v-text-field--enclosed .v-input__append-outer {
        margin-top: 7px !important;
    }
    .view-select-container .v-select.v-text-field--outlined:not(.v-text-field--single-line) .v-select__selections {
        padding-top: 4px !important;
        padding-bottom: 2px !important;
    }
    .view-select-container .v-text-field--outlined .v-label {
        top: 11px !important;
    }
    .view-select-container .v-text-field--outlined .v-label--active {
        top: 17px !important;
    }

    .to-tracking-number {
        color: #0000FF;
        font-weight: bold;
        text-decoration: underline;
        cursor: pointer;
    }
    #ag-grid-issues-container .ag-row-selected .to-tracking-number {
        color: #ffffff;
    }
</style>